// Generated by Melange

import * as Buhta_cabinet__Panel from "../html/Panel.js";
import * as Buhta_cabinet__ReceiptBody from "../organisms/Kassa/KKM/ReceiptBody.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

const Styles = {
  section: "py-4 border-b border-gray-main",
  sectionItem: "grid grid-cols-1-auto"
};

function make(receipt) {
  return function (leftActionsOpt) {
    const leftActions = leftActionsOpt !== undefined ? leftActionsOpt : /* [] */0;
    return function (borderedOpt) {
      const bordered = borderedOpt !== undefined ? borderedOpt : true;
      return function (shadowedOpt) {
        const shadowed = shadowedOpt !== undefined ? shadowedOpt : true;
        return function (titleAlignOpt) {
          const titleAlign = titleAlignOpt !== undefined ? titleAlignOpt : "center";
          return function (className) {
            return function (fullWidthOpt) {
              return function (roundedOpt) {
                const rounded = roundedOpt !== undefined ? roundedOpt : true;
                return function (kkm) {
                  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
                  const dispatchToasts = match[1];
                  const className$1 = Cn.fromList({
                        hd: "panel--receipt",
                        tl: {
                          hd: Cn.take(className),
                          tl: /* [] */0
                        }
                      });
                  return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                              title: "Чек №" + String(receipt.serial_id),
                              titleAlign: Caml_obj.caml_equal(leftActions, /* [] */0) ? "left" : titleAlign,
                              leftActions: leftActions,
                              rightActions: {
                                hd: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
                                      text: window.location.protocol + ("//" + (window.location.host + ("/receipt/" + (String(kkm.id) + ("/" + receipt.id))))),
                                      onCopy: (function (param) {
                                          Curry._1(dispatchToasts, {
                                                TAG: /* Add */0,
                                                _0: {
                                                  id: Buhta_core__Toast.generateId(undefined),
                                                  text: "Ссылка скопирована",
                                                  kind: "success",
                                                  onClick: (function (param) {
                                                      
                                                    })
                                                }
                                              });
                                        }),
                                      children: JsxRuntime.jsx("img", {
                                            className: "w-5 h-5 cursor-pointer",
                                            src: StaticAsset.src("/static/icons/link.svg")
                                          })
                                    }),
                                tl: {
                                  hd: JsxRuntime.jsx("a", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-5 h-5",
                                              src: StaticAsset.src("/static/icons/share.svg")
                                            }),
                                        href: "/receipt/" + (String(kkm.id) + ("/" + receipt.id)),
                                        target: "_blank"
                                      }),
                                  tl: /* [] */0
                                }
                              },
                              shadowed: shadowed,
                              bordered: bordered,
                              rounded: rounded,
                              className: className$1,
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_cabinet__ReceiptBody.make, {
                                                      receipt: receipt
                                                    }),
                                                className: "w-122"
                                              }),
                                          className: Cn.$plus("p-6 overflow-y-auto", "flex justify-center")
                                        }),
                                    className: Cn.$plus("flex flex-col", "w-full")
                                  })
                            });
                };
              };
            };
          };
        };
      };
    };
  };
}

function ReceiptPanel(Props) {
  return Curry._7(make(Props.receipt)(Props.leftActions), Props.bordered, Props.shadowed, Props.titleAlign, Props.className, Props.fullWidth, Props.rounded, Props.kkm);
}

const make$1 = ReceiptPanel;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_cabinet__Panel Not a pure module */
